import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { JwtService } from '../../services/jwt.service';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { NzFlexDirective } from 'ng-zorro-antd/flex';

@Component({
  selector: 'app-pin-entry',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzCardModule,
    NzIconModule,
    TranslatePipe,
    NzFlexDirective,
  ],
  templateUrl: './pin-entry.component.html',
  styleUrl: './pin-entry.component.scss',
})
export class PinEntryComponent {
  jwtService = inject(JwtService);
  router = inject(Router);
  http = inject(HttpClient);
  fb = inject(FormBuilder);
  message = inject(NzMessageService);

  isLoading = false;

  form = this.fb.group({
    pin: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
  });

  async enterPin() {
    if (this.form.invalid) {
      this.message.error('Please enter a valid 4-digit PIN');
      return;
    }

    this.isLoading = true;
    try {
      const url = new URL('/auth/pin-login', environment.apiUrl).href;
      const response = await firstValueFrom(
        this.http.post<{ access_token: string; device_token?: string }>(url, {
          pin: this.form.value.pin,
        })
      );

      // Replace device token with employee token
      this.jwtService.setToken(response.access_token);
      if (response.device_token) {
        this.jwtService.setDeviceToken(response.device_token);
      }
      this.router.navigateByUrl('/dashboard');
    } catch (error: any) {
      console.error('PIN login failed:', error);
      if (error.status === 401) {
        this.message.error('Invalid PIN. Please try again.');
        this.form.reset();
      } else {
        this.message.error('Login failed. Please try again.');
      }
    } finally {
      this.isLoading = false;
    }
  }

  logout() {
    // Full logout - clear all tokens
    this.jwtService.unsetToken();
  }
}
